import { UserConfigService } from '@/scripts/services/user-config-service';
import { helpers } from '@/scripts/helpers';

const WOLI_USER_CONFIG_TYPE = 'ai';

export const woli = {
    namespaced: true,

    state: () => ({
        isEnabled: true,
        isUserConfigLoading: false,
        isUserConfigSaving: false,
        isPopupOpen: false,
        userConfig: { woliEnabled: true },
        sessionEnabled: {},
    }),

    mutations: {
        setIsPopupOpen(state, payload) {
            state.isPopupOpen = payload;
        },
    },

    actions: {
        async loadUserConfig({ state, rootState }) {
            if(!rootState.isLoggedIn) {
                return Promise.resolve();
            }

            state.isUserConfigLoading = false;

            try {
                const response = await UserConfigService.loadUserConfig(WOLI_USER_CONFIG_TYPE);
                const config = response.config;

                if(Object.keys(config).length !== 0) {
                    state.userConfig = config;
                    state.isEnabled = config.woliEnabled;
                }
            }
            catch (error) {
                helpers.showFailNotification(
                    'Failed to load WOLI preferences',
                    { error, enable: false },
                );

                state.userConfig = null;
            }
            finally {
                state.isUserConfigLoading = false;
            }
        },

        unloadUserConfig({ state }) {
            state.isEnabled = true;
            state.isUserConfigLoading = false;
            state.isUserConfigSaving = false;
            state.isPopupOpen = false;
            state.userConfig = null;
        },

        async saveUserConfig({ state, rootState }) {
            const userConfig = state.userConfig;

            if(!userConfig) {
               return Promise.reject('No user config found');
            }

            if(!rootState.isLoggedIn) {
                return Promise.resolve();
            }

            state.isEnabled = userConfig.woliEnabled;
            state.isUserConfigSaving = true;

            await UserConfigService.saveUserConfig(WOLI_USER_CONFIG_TYPE, userConfig);
            state.isUserConfigSaving = false;
        },

        async updateEnabled({ state, dispatch }, payload) {
            state.userConfig.woliEnabled = payload;
            state.isEnabled = payload;

            try {
                await dispatch('saveUserConfig');
                helpers.showSuccessNotification('WOLI preferences saved');
            }
            catch (error) {
                helpers.showFailNotification(
                    'Failed to save WOLI preferences',
                    { error }
                );
            }
        },

        setSessionEnabled({ state }, { sessionId, enabled }) {
            state.sessionEnabled = {
                ...state.sessionEnabled,
                [sessionId]: enabled,
            };
        },
    },
};